// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import ReactPaginate from 'react-paginate'
// import * as XLSX from 'xlsx'
// import DatePicker from 'react-multi-date-picker'
// import { DateObject } from 'react-multi-date-picker'
// import Loader from 'react-js-loader'
// import loader from '../icons/loder.gif'
// import { apiRequest } from '../apiServices/allApi'
// import { Link } from '@mui/material'


// const $ = require('jquery')
// $.Datatable = require('datatables.net')

// function Earings () {
//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
//   const nodeMode = process.env.NODE_ENV
//   if (nodeMode === 'development') {
//     var baseUrl = beckendLocalApiUrl
//   } else {
//     var baseUrl = beckendLiveApiUrl
//   }

//   //use for pagination..
//   let [limit, setLimit] = useState(20)
//   const [loading, setLoading] = useState(false)
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)

//   const setpageLimit = event => {
//     let key = event.target.value
//     setLimit(key)
//   }

//   const [EARING, setEARING] = useState()
//   const [ExportData, setExportData] = useState()
//   const [Total, setTotal] = useState()
//   const [TOTELEARING, setTOTELEARING] = useState()

//   const Year = new Date().getFullYear();
//   const Month = new Date().getMonth() + 1; // Adding 1 to the month since getMonth() returns 0-11
  
//   const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;
  
//   const dynamicStartDate = `${Year}/${formattedMonth}/01`;
//   const dynamicEndDate = `${Year}/${formattedMonth}/31`;
  
//   const [startDate, setStartDate] = useState(dynamicStartDate);
//   const [endDate, setEndDate] = useState(dynamicEndDate);

//   const handleStartDateChange = (date) => {
//     setStartDate(date);
//   };

//   const handleEndDateChange = (date) => {
//     setEndDate(date);
//   };

//   //react paginate..
//   const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//     // scroll to the top
//     //window.scrollTo(0, 0)
//   }

//   // useEffect(() => {
//   //   const access_token = localStorage.getItem('token')
//   //   setLoading(true)
//   //   const headers = {
//   //     Authorization: `Bearer ${access_token}`
//   //   }
//   //   axios
//   //     .get(
//   //       baseUrl +
//   //       `admin/Earning?page=${pageNumber}&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`,
//   //       { headers }
//   //     )
//   //     .then(res => {
//   //   setLoading(false)
//   //       setEARING(res.data.admin)
//   //       setNumberOfPages(res.data.totalPages)
//   //       //$('table').dataTable();
//   //     }).catch(
//   //   setLoading(false)
//   //     )
//   //   axios.get(baseUrl + `admin/Earning/total`, { headers }).then(res => {
//   //     setLoading(false)
//   //     setTOTELEARING(res.data.total)
//   //   })
//   // }, [pageNumber, limit, startDate, endDate])

//    const exportData = async () => {
//      const access_token = localStorage.getItem('token')
//     setLoading(true)
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//       try {
//         const res = await apiRequest(`admin/Earning/export?&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`, 'GET',null , headers);
//         setLoading(false)
//         setExportData(res.data.admin)
//         setTotal(res.data)

//       } catch (error) {
//         setLoading(false)
//       } finally {
//         const res = await apiRequest(`admin/Earning/total`, 'GET',null , headers);
//         setLoading(false)
//         setTOTELEARING(res.data.total)
  
//       }
//     }


//   useEffect(() => {
//     const access_token = localStorage.getItem('token')
//     setLoading(true)
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     const fetchData = async () => {
//       try {
//         const res = await apiRequest(`admin/Earning?page=${pageNumber}&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`, 'GET',null , headers);
//         setLoading(false)
//         setEARING(res.data.admin)
//             // console.log(setEARING)
//         setNumberOfPages(res.data.totalPages)

//       } catch (error) {
//         setLoading(false)
//       } finally {
//         const res = await apiRequest(`admin/Earning/total`, 'GET',null , headers);
//         setLoading(false)
//         setTOTELEARING(res.data.total)
  
//       }
//     }
   
//     fetchData()
//     exportData()
//   },[pageNumber, limit, startDate, endDate])



//   const dateFormat = e => {
//   const date = new Date(e);

//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   const ampm = hours >= 12 ? 'PM' : 'AM';

//   hours = hours % 12 || 12; // convert to 12-hour format

//   return `${day}-${month}-${year} at ${hours}:${minutes} ${ampm}`;
// };

//   const createDownloadData = () => {
//     handleExport()
//     exportData()
//   }
//   const handleExport = () => {
//     let table1 = [
//       {
//         A: 'id',
//         B: 'Amount'
//         // F:"Bonus by (ID)"
//       }
//     ]

//     ExportData?.forEach(row => {
//       const Earing = row
//       console.log('exldata', Earing)
//       table1.push({
//         A: `Earn From Challange ${Earing.Earned_Form} on ${dateFormat(Earing.createdAt)}`,
//         B: Earing.Ammount
//         // F:(userDetails.action_by)?userDetails.action_by:'N/A'
//       })
//     })

//     //table1 = [{A:"User Details"}].concat(table1);
//     //const finalData = [...table1];
//     //console.log(finalData);
//     /* convert state to workbook */
//     const ws = XLSX.utils.json_to_sheet(table1, {
//       skipHeader: true
//     })
//     const wb = XLSX.utils.book_new()
//     XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
//     /* generate XLSX file and send to client */
//     XLSX.writeFile(wb, 'AdminEarning.xlsx')
//   }

//   return loading ? (
//     <>
//        <div className='App'>
//         <div className='item dashboaed_loader'>
//           <Loader
//             type='bubble-ping'
//             bgColor={'#fff'}
//             title={<img src={loader} alt='Loading...' />}
//             color={'#000'}
//             size={100}
//           />
//         </div>
//       </div>
//     </>
//   ) : (
//     <>
//       <div className='row '>
//         <div className='col-12 grid-margin'>
//           <div className='card text-white'>
//             <div className='card-body text-light table_bg'>
//               <div className='mt-3'>
//                 <h3 className='d-flex flex-row dashboard_heading'>
//                   Admin Total Earing : ₹ {TOTELEARING}
//                 </h3>
//                 <div className='d_flex_both_center'>
//                   <select
//                     className='form-control col-sm-1 m-1'
//                     id='pagelimit'
//                     name='pagelimit'
//                     onChange={setpageLimit}
//                   >
//                     <option value='10'>Set limit</option>
//                     <option value='20'>20</option>
//                     <option value='50'>50</option>
//                     <option value='100'>100</option>
//                     <option value='500'>500</option>
//                   </select>
//                   <div className=''>
//                     {/* <DatePicker
//                       value={values}
//                       onChange={setValues}
//                       range
//                       style={{ height: '40px' }}
//                     /> */}
//                                <DatePicker
//         selected={startDate}
//         value={startDate}
//         onChange={handleStartDateChange}
//         selectsStart
//         startDate={startDate}
//         endDate={endDate}
//         placeholderText="Start Date"
//         style={{ height: '40px' }}
//       />
//       {/* <span style={{color:"black"}}></span> */}
//       <DatePicker
//         selected={endDate}
//         onChange={handleEndDateChange}
//         value={endDate}
//         selectsEnd
//         startDate={startDate}
//         endDate={endDate}
//         placeholderText="End Date"
//         minDate={startDate} // Ensure that the end date cannot be before the start date
//         style={{ height: '40px' }}
//       />
//                     <button
//                       onClick={() => {
//                         createDownloadData()
//                       }}
//                       className='btn btn-primary ml-2'
//                       style={{ height: '40px' }}
//                     >
//                       Export Data
//                     </button>
//                     <button
                    
//                       className='btn btn-primary ml-2'
//                       style={{ height: '40px' }}
//                     >
//                       {Total?.totalAmount}
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               <div className='table-responsive'>
//                 <table className='table text-white'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th> _id </th>
//                       <th>Amount</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {EARING &&
//                       EARING.map((Earing, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>
//                             <div className='d-flex'>
//                               <span className='pl-2'>
//                                 Earn From Game
//                               </span>
//                               <a className='pl-2' href={`view/${Earing.Game_id}`}>
//                                  {Earing.Game_id}
//                               </a>
//                                <span className='pl-2'>
//                                  on{' '}
//                               {dateFormat(Earing.createdAt)}
//                                </span>
//                             </div>
//                           </td>

//                           <td>
//                             <div className=''>{Earing.Ammount}</div>
//                           </td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Earings


import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import * as XLSX from 'xlsx'
import DatePicker from 'react-multi-date-picker'
import { DateObject } from 'react-multi-date-picker'
import Loader from 'react-js-loader'
import loader from '../icons/loder.gif'
import { apiRequest } from '../apiServices/allApi'
import { Link } from '@mui/material'
// import './Earings.css'

const $ = require('jquery')
$.Datatable = require('datatables.net')

function Earings () {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    var baseUrl = beckendLiveApiUrl
  }

  // Pagination states
  let [limit, setLimit] = useState(20)
  const [loading, setLoading] = useState(false)
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }

  const [EARING, setEARING] = useState()
  const [ExportData, setExportData] = useState()
  const [Total, setTotal] = useState()
  const [TOTELEARING, setTOTELEARING] = useState()

  const Year = new Date().getFullYear();
  const Month = new Date().getMonth() + 1;
  
  const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;
  
  const dynamicStartDate = `${Year}/${formattedMonth}/01`;
  const dynamicEndDate = `${Year}/${formattedMonth}/31`;
  
  const [startDate, setStartDate] = useState(dynamicStartDate);
  const [endDate, setEndDate] = useState(dynamicEndDate);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const exportData = async () => {
    const access_token = localStorage.getItem('token')
    setLoading(true)
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`admin/Earning/export?&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`, 'GET', null, headers);
      setLoading(false)
      setExportData(res.data.admin)
      setTotal(res.data)
    } catch (error) {
      setLoading(false)
    } finally {
      const res = await apiRequest(`admin/Earning/total`, 'GET', null, headers);
      setLoading(false)
      setTOTELEARING(res.data.total)
    }
  }

  useEffect(() => {
    const access_token = localStorage.getItem('token')
    setLoading(true)
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    const fetchData = async () => {
      try {
        const res = await apiRequest(`admin/Earning?page=${pageNumber}&_limit=${limit}&FROM_DATE=${startDate}&TO_DATE=${endDate}`, 'GET', null, headers);
        setLoading(false)
        setEARING(res.data.admin)
        setNumberOfPages(res.data.totalPages)
      } catch (error) {
        setLoading(false)
      } finally {
        const res = await apiRequest(`admin/Earning/total`, 'GET', null, headers);
        setLoading(false)
        setTOTELEARING(res.data.total)
      }
    }
   
    fetchData()
    exportData()
  }, [pageNumber, limit, startDate, endDate])

  const dateFormat = e => {
    const date = new Date(e);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${day}-${month}-${year} at ${hours}:${minutes} ${ampm}`;
  };

  const createDownloadData = () => {
    handleExport()
    exportData()
  }

  const handleExport = () => {
    let table1 = [
      {
        A: 'id',
        B: 'Amount'
      }
    ]

    ExportData?.forEach(row => {
      const Earing = row
      table1.push({
        A: `Earn From Challange ${Earing.Earned_Form} on ${dateFormat(Earing.createdAt)}`,
        B: Earing.Ammount
      })
    })

    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true
    })
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
    XLSX.writeFile(wb, 'AdminEarning.xlsx')
  }

  return loading ? (
    <div className='App'>
      <div className='item dashboaed_loader'>
        <Loader
          type='bubble-ping'
          bgColor={'#fff'}
          title={<img src={loader} alt='Loading...' />}
          color={'#000'}
          size={100}
        />
      </div>
    </div>
  ) : (
    <div className='earning-page-container'>
      <div className='earning-card-main'>
        
        {/* Header & Total Earnings Badge */}
        <div className='earning-header-flex'>
          <h3 className='earning-title'>Admin Earnings Overview</h3>
          <div className='total-earning-badge'>
            Total Earnings: ₹ {TOTELEARING}
          </div>
        </div>

        {/* Filter Controls Bar */}
        <div className='earning-filter-bar'>
          <div className='filter-left-controls'>
            <select
              className='custom-select-limit'
              id='pagelimit'
              name='pagelimit'
              onChange={setpageLimit}
            >
              <option value='10'>Limit: 10</option>
              <option value='20'>Limit: 20</option>
              <option value='50'>Limit: 50</option>
              <option value='100'>Limit: 100</option>
              <option value='500'>Limit: 500</option>
            </select>

            <div className='custom-datepicker-input'>
              <DatePicker
                selected={startDate}
                value={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
              />
            </div>

            <div className='custom-datepicker-input'>
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                value={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                placeholderText="End Date"
                minDate={startDate}
              />
            </div>
          </div>

          <div className='filter-right-actions'>
            <button
              onClick={createDownloadData}
              className='btn-export-excel'
            >
              Export Data (.xlsx)
            </button>
            {Total?.totalAmount && (
              <div className='btn-total-info'>
                Selected Range: ₹ {Total?.totalAmount}
              </div>
            )}
          </div>
        </div>

        {/* Responsive Table Wrapper */}
        <div className='table-responsive-wrapper'>
          <table className='earning-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>Earning Details & Game ID</th>
                <th>Commission Amount</th>
              </tr>
            </thead>
            <tbody>
              {EARING &&
                EARING.map((Earing, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <div className='d-flex align-items-center gap-2'>
                        <span style={{ color: '#cbd5e1' }}>Earn From Game</span>
                        <a className='game-id-link' href={`view/${Earing.Game_id}`}>
                          {Earing.Game_id}
                        </a>
                        <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
                          on {dateFormat(Earing.createdAt)}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className='amount-text'>₹ {Earing.Ammount}</div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Container */}
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-content-center'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>
      </div>
    </div>
  )
}

export default Earings
